import { Box, Typography, IconButton, Icon, Tooltip } from '@mui/material'
import { useState } from 'react'
import { FullscreenExit } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { useStyles } from './styles'
import { EvidencesTypeValueEnum } from '../../../../../../../utils/enums/evidences'
import { FileModal } from '../../../../../../reportFolio/pages/dashboard/components/fileModal'
import { CustomPaper } from '../../../../../../../components/CustomPaper'
import { icons } from '../../../../../../../utils/icons'
import { EvidencesCardMap } from './types'

const EvidencesMap = ({ evidences, type }: EvidencesCardMap) => {
    const styles = useStyles()
    const { t } = useTranslation()
    const [modal, setModal] = useState({
        open: false,
        src: ''
    })

    const downloadFile = async (url: string, filename: string) => {
        const response = await fetch(url);
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(blobUrl);
    };

    function displayMedia({ src }: { src: string }) {
        setModal(prev => ({ ...prev, open: true, src }))
    }
    function closeModal() {
        setModal(prev => ({ ...prev, open: false }))
    }
    const sharedVideoComponent = (
        <Box>
            <CustomPaper elevation={2} sx={styles.videos}>
                <video >
                    <source src={evidences?.src} type="video/mp4" />
                </video>

                <IconButton onClick={() => { displayMedia({ src: evidences?.src }) }} sx={styles.expand}><FullscreenExit /></IconButton>
            </CustomPaper>

            <FileModal src={modal.src} modalProps={{ open: modal.open, addClose: true, close: { onClick: closeModal } }} type={EvidencesTypeValueEnum.VIDEO} />
        </Box>
    )
    const sharedImageComponent = (
        <Box>
            <CustomPaper elevation={2} sx={styles.images} >
                <img src={evidences?.src} alt="" />
                <IconButton onClick={() => { displayMedia({ src: evidences?.src }) }} sx={styles.expand}><FullscreenExit /></IconButton>
            </CustomPaper>

            <FileModal src={modal.src} modalProps={{ open: modal.open, addClose: true, close: { onClick: closeModal } }} type={EvidencesTypeValueEnum.IMAGE} />
        </Box>
    )
    const components = {

        [EvidencesTypeValueEnum.VIDEO]: sharedVideoComponent,
        [EvidencesTypeValueEnum.VIDEO_GALLERY]: sharedVideoComponent,
        [EvidencesTypeValueEnum.IMAGE]: sharedImageComponent,
        [EvidencesTypeValueEnum.CAMERA]: sharedImageComponent,
        [EvidencesTypeValueEnum.SIGN]: (
            <Box sx={{ paddingTop: 1 }}>
                <CustomPaper elevation={2} sx={styles.images}>
                    <img src={evidences?.src} alt="" />
                    <IconButton onClick={() => { displayMedia({ src: evidences?.src }) }} sx={styles.expand}><FullscreenExit /></IconButton>
                </CustomPaper>

                <FileModal src={modal.src} modalProps={{ open: modal.open, addClose: true, close: { onClick: closeModal } }} type={EvidencesTypeValueEnum.IMAGE} />
            </Box>
        ),
        [EvidencesTypeValueEnum.COMMENT]: (
            <CustomPaper elevation={2} sx={styles.comments}>
                <Tooltip /* sx={{display:'flex'}} */ title={evidences?.name} placement="top" arrow>
                    <Typography
                        className="bold full-w title-three"
                        sx={{
                            display: '-webkit-box',
                            WebkitLineClamp: 3, // Número de líneas antes de cortar
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }}
                    >
                        {evidences?.name ?? ''}
                    </Typography>
                </Tooltip>
            </CustomPaper>
        ),
        [EvidencesTypeValueEnum.DOCUMENT]: (
            <CustomPaper
                elevation={2}
                sx={styles.documentItems}
                onClick={() => {
                    if (evidences?.src) {
                        //const extension = evidences.src.split('.com/').pop()?.toLowerCase();
                        const extensionSecond = evidences.src.split('.').pop()?.toLowerCase();
                        if (extensionSecond !== 'pdf') {
                            downloadFile(evidences.src, evidences?.name ?? 'documento');
                        } else {
                            window.open(evidences.src, 'blank');
                        }
                    }
                }}
            >
                <Box sx={styles.boxIcon}>
                    <Icon>{icons('paper')}</Icon>
                    <Tooltip /* sx={{display:'flex'}} */ title={evidences?.name} placement="top" arrow>
                        <Typography
                            variant="subtitle"
                            sx={{
                                display: '-webkit-box',
                                WebkitLineClamp: 2, // Número de líneas antes de cortar
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                textDecoration: ' underline',
                                textAlign: 'center'
                            }}
                        >
                            {evidences?.name}
                        </Typography>
                    </Tooltip>
                </Box>
            </CustomPaper>
        ),
    }

    return components[type] ?? <p>{t('reportFolio.detail.general.noFound')}</p>
}

export { EvidencesMap }